"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require("babel-runtime/helpers/extends");

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var PropTypes = _interopRequireWildcard(_propTypes);

var _reactstrap = require("reactstrap");

require("./DateRangeField.scss");

var _DateField = require("./DateField");

var _DateField2 = _interopRequireDefault(_DateField);

var _FieldLabel = require("../form/FieldLabel");

var _FieldLabel2 = _interopRequireDefault(_FieldLabel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * field pro range date
 */
var DateRangeField = function (_React$Component) {
    (0, _inherits3.default)(DateRangeField, _React$Component);

    function DateRangeField() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DateRangeField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DateRangeField.__proto__ || (0, _getPrototypeOf2.default)(DateRangeField)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnChange = function (inputValue, key) {
            var _this$props = _this.props,
                value = _this$props.value,
                onChange = _this$props.onChange;

            var formValue = (0, _extends4.default)({}, value, (0, _defineProperty3.default)({}, key, inputValue.target.value));
            onChange && onChange(formValue);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(DateRangeField, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                value = _props.value,
                dateFromKey = _props.dateFromKey,
                dateToKey = _props.dateToKey;

            return _react2.default.createElement(
                _reactstrap.Row,
                { className: "no-gutters posv-date-range-field" },
                _react2.default.createElement(
                    _reactstrap.Col,
                    { sm: { size: 6 } },
                    _react2.default.createElement(
                        _reactstrap.Row,
                        { className: "no-gutters" },
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { sm: { size: 2 }, className: "date-range-label" },
                            _react2.default.createElement(_FieldLabel2.default, { label: "Od" })
                        ),
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { sm: { size: 10 } },
                            _react2.default.createElement(_DateField2.default, { value: value && value[dateFromKey],
                                label: false,
                                onChange: function onChange(inputValue) {
                                    return _this2.handleOnChange(inputValue, dateFromKey);
                                } })
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactstrap.Col,
                    { sm: { size: 6 } },
                    _react2.default.createElement(
                        _reactstrap.Row,
                        { className: "no-gutters" },
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { sm: { size: 2 }, className: "date-range-label" },
                            _react2.default.createElement(_FieldLabel2.default, { label: "Do" })
                        ),
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { sm: { size: 10 } },
                            _react2.default.createElement(_DateField2.default, { value: value && value[dateToKey],
                                label: false,
                                onChange: function onChange(inputValue) {
                                    return _this2.handleOnChange(inputValue, dateToKey);
                                } })
                        )
                    )
                )
            );
        }
    }]);
    return DateRangeField;
}(_react2.default.Component);

DateRangeField.propTypes = {
    dateFromKey: PropTypes.string.isRequired,
    dateToKey: PropTypes.string.isRequired
};
DateRangeField.defaultProps = {
    dateFromKey: "datumOd",
    dateToKey: "datumDo"
};
exports.default = DateRangeField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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